import React, { useEffect } from 'react';
import { Row, Col, Typography, Divider, Button } from 'antd';
import {
  CustomText,
  CustomTextArea,
  FormDatePicker,
  FormInput,
  FormSelect,
  UploadWithTable,
} from '../../../../components';
import {
  formatNumber,
  handleInvoiceValueChange,
  UploadedFile,
} from '../../../../utils';
import { AuthResponse } from '../../../Auth/types';
import { ShareResponse, useListTerceros } from '../../../../share';
import { ENTRY_TYPE } from '../../types';
import FormSelectSearch from '../../../../components/FormSelectSearch/FormSelectSearch';
import dayjs from 'dayjs';

const { Title } = Typography;

interface EntryRequestCreateViewProps {
  formik: any;
  entyTypes?: ShareResponse[];
  itemTypes?: ShareResponse[];
  entryStates?: ShareResponse[];
  entryDevelivery?: ShareResponse[];
  sedes?: ShareResponse[];
  dependencies?: ShareResponse[];
  authData?: AuthResponse | null;
  onFiles: (files: UploadedFile[]) => void;
  setIsOpen?: (value: boolean) => void;
  files?: UploadedFile[];
  isOpen?: boolean;
}

const EntryRequestCreateView: React.FC<EntryRequestCreateViewProps> = ({
  formik,
  entyTypes,
  itemTypes,
  entryDevelivery,
  sedes,
  authData,
  isOpen,
  files,
  onFiles,
  setIsOpen,
  dependencies,
}) => {
  const storedToken = localStorage.getItem('auth');
  const parsedToken = storedToken ? JSON.parse(storedToken) : null;
  const token = parsedToken?.authorization?.token;
  const { data } = useListTerceros(token);
  const terceros = data?.third_party || [];

  useEffect(() => {
    if (isOpen) {
      formik.setFieldValue('requester_id', authData?.user.id);
      formik.setFieldValue(
        'entry_requester_section_id',
        authData?.user.branch_id
      );

      formik.setFieldValue(
        'requester_name',
        `${authData?.user.name} ${authData?.user.last_name}`
      );
    }
  }, [isOpen]);
  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Solicitante"
            name="requester_id"
            placeholder={`${authData?.user.document} - ${authData?.user.name} ${authData?.user.last_name}`}
            value=""
            disabled
            error={formik.errors.requester_id}
            touched={formik.touched.requester_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <input
            type="hidden"
            name="requester_id"
            value={authData?.user.id}
            onChange={formik.handleChange}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Tipo de entrada"
            name="entry_type"
            placeholder="Seleccione"
            value={formik.values.entry_type}
            options={entyTypes?.map((option) => {
              let textFormat =
                option.name.charAt(0).toUpperCase() +
                option.name.slice(1).toLowerCase();
              return {
                id: option.id,
                name: textFormat,
              };
            })}
            error={formik.errors.entry_type}
            touched={formik.touched.entry_type}
            onChange={(value) => {
              formik.setFieldValue('entry_type', value);
              formik.setFieldValue('query_date', dayjs());
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Cantidad entregas estipuladas"
            name="deliveries"
            min="0"
            placeholder="Seleccione"
            type="number"
            value={formik.values.deliveries}
            error={formik.errors.deliveries}
            touched={formik.touched.deliveries}
            onChange={(e) => {
              const value = e.target.value;

              if (/^\d{0,11}$/.test(value)) {
                formik.setFieldValue('deliveries', Number(value));
              }
            }}
            onBlur={(e) => {
              if (Number(!e.target.value) || Number(e.target.value) < 0) {
                formik.setFieldValue('deliveries', 0);
              }
            }}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Seccional entrada"
            name="entry_section_id"
            placeholder="Seleccione"
            value={formik.values.entry_section_id}
            options={sedes}
            error={formik.errors.entry_section_id}
            touched={formik.touched.entry_section_id}
            onChange={(value) =>
              formik.setFieldValue('entry_section_id', value)
            }
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Seccional del solicitante"
            name="entry_requester_section_id"
            placeholder="Seleccione"
            value={formik.values.entry_requester_section_id}
            options={sedes}
            error={formik.errors.entry_requester_section_id}
            touched={formik.touched.entry_requester_section_id}
            onChange={(value) =>
              formik.setFieldValue('entry_requester_section_id', value)
            }
            onBlur={formik.handleBlur}
            disabled
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Tipo de bien"
            name="item_type"
            placeholder="Seleccione"
            value={formik.values.item_type}
            options={itemTypes}
            error={formik.errors.item_type}
            touched={formik.touched.item_type}
            onChange={(value) => {
              formik.setFieldValue('item_type', value);
            }}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Dependencia"
            name="dependency_id"
            placeholder="Seleccione"
            value={formik.values.dependency_id}
            options={dependencies?.map((it: any) => {
              return {
                ...it,
                name:
                  it?.code +
                  ' - ' +
                  it?.name +
                  ' / ' +
                  it.responsible?.branch?.code +
                  ' - ' +
                  it.responsible?.branch?.name +
                  ' / ' +
                  it.area?.code +
                  ' ' +
                  it.area?.name,
              };
            })}
            error={formik.errors.dependency_id}
            touched={formik.touched.dependency_id}
            onChange={(value) => formik.setFieldValue('dependency_id', value)}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Entregas en otras seccionales"
            name="other_deliver"
            placeholder="Seleccione"
            value={formik.values.other_deliver}
            options={entryDevelivery?.map((value) => {
              return {
                ...value,
                id: String(value.id),
              };
            })}
            error={formik.errors.other_deliver}
            touched={formik.touched.other_deliver}
            onChange={(value) => formik.setFieldValue('other_deliver', value)}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormDatePicker
            label="Fecha de solicitud"
            name="query_date"
            value={formik.values.query_date}
            error={formik.errors.query_date}
            touched={formik.touched.query_date}
            onChange={(value) => formik.setFieldValue('query_date', value)}
            onBlur={formik.handleBlur}
            placeholder={formik.values.query_date}
            disabled={formik.values.entry_type !== ENTRY_TYPE.CONTRATO}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Estado de solicitud"
            name="example"
            value="Nuevo"
            disabled
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Número de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe"
            name="invoice_number"
            placeholder="Inserte"
            value={formik.values.invoice_number}
            error={formik.errors.invoice_number}
            touched={formik.touched.invoice_number}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormDatePicker
            label="Fecha de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe"
            name="invoice_date"
            value={formik.values.invoice_date}
            error={formik.errors.invoice_date}
            touched={formik.touched.invoice_date}
            onChange={(value) => formik.setFieldValue('invoice_date', value)}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Cantidad de facturas"
            name="invoice_count"
            placeholder="Seleccione"
            type="text"
            min="0"
            value={formik.values.invoice_count}
            error={formik.errors.invoice_count}
            touched={formik.touched.invoice_count}
            onChange={(e) => {
              const value = e.target.value;

              if (/^\d{0,11}$/.test(value)) {
                formik.setFieldValue('invoice_count', Number(value));
              }
            }}
            onBlur={(e) => {
              if (Number(!e.target.value) || Number(e.target.value) < 0) {
                formik.setFieldValue('invoice_count', 0);
              }
            }}
          />
        </Col>
      </Row>
      {formik.values.entry_type === '' && (
        <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Supervisor"
              name="supervisor"
              placeholder="Nombre y Apellido"
              value={formik.values.supervisor}
              error={formik.errors.supervisor}
              touched={formik.touched.supervisor}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      )}

      {/* ORDEN DE COMPRA */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.ORDEN_COMPRA?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Supervisor"
              name="supervisor"
              placeholder="Nombre y Apellido"
              value={formik.values.supervisor}
              error={formik.errors.supervisor}
              touched={formik.touched.supervisor}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Número de orden de compra"
              name="purchase_order"
              placeholder="Inserte"
              value={formik.values.purchase_order}
              error={formik.errors.purchase_order}
              touched={formik.touched.purchase_order}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Rubro presupuestal"
              name="budget_item"
              type="text"
              placeholder="Inserte"
              value={formik.values.budget_item}
              error={formik.errors.budget_item}
              touched={formik.touched.budget_item}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      )}
      {/* CONTRATO */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.CONTRATO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Supervisor"
              name="supervisor"
              placeholder="Nombre y Apellido"
              value={formik.values.supervisor}
              error={formik.errors.supervisor}
              touched={formik.touched.supervisor}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      )}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.CONTRATO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Número de contrato"
              name="contract_number"
              placeholder="Inserte"
              value={formik.values.contract_number}
              error={formik.errors.contract_number}
              touched={formik.touched.contract_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha inicio contrato"
              name="contract_start_date"
              value={formik.values.contract_start_date}
              error={formik.errors.contract_start_date}
              touched={formik.touched.contract_start_date}
              onChange={(value) =>
                formik.setFieldValue('contract_start_date', value)
              }
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha final contrato"
              name="contract_end_date"
              value={formik.values.contract_end_date}
              error={formik.errors.contract_end_date}
              touched={formik.touched.contract_end_date}
              onChange={(value) =>
                formik.setFieldValue('contract_end_date', value)
              }
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Rubro presupuestal"
              name="budget_item"
              type="text"
              placeholder="Inserte"
              value={formik.values.budget_item}
              error={formik.errors.budget_item}
              touched={formik.touched.budget_item}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      )}

      {/* SENTENCIA JUDUCIALjudgment */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.COMISO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormSelectSearch
              label="Juzgado de conocimiento"
              name="judgment_court_name"
              placeholder="Inserte"
              options={terceros}
              value={formik.values.judgment_court_name}
              error={formik.errors.judgment_court_name}
              touched={formik.touched.judgment_court_name}
              onChange={(value) =>
                formik.setFieldValue('judgment_court_name', value)
              }
              onBlur={() => formik.setFieldTouched('judgment_court_name', true)}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Noticia criminal"
              name="judgment_process_number"
              placeholder="Inserte"
              value={formik.values.judgment_process_number}
              error={formik.errors.judgment_process_number}
              touched={formik.touched.judgment_process_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
        </Row>
      )}

      {/* DONACION */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.DONACION?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Documento de donación"
              name="donation_document"
              placeholder="Documento"
              value={formik.values.donation_document}
              error={formik.errors.donation_document}
              touched={formik.touched.donation_document}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
        </Row>
      )}

      {/* comodato */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.COMODATO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Número de contrato comodato"
              name="comodato_contract_number"
              placeholder="número contrato"
              type="text"
              value={formik.values.comodato_contract_number}
              error={formik.errors.comodato_contract_number}
              touched={formik.touched.comodato_contract_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha inicio de contrato comodato"
              name="comodato_start_date"
              value={formik.values.comodato_start_date}
              error={formik.errors.comodato_start_date}
              touched={formik.touched.comodato_start_date}
              onChange={(value) =>
                formik.setFieldValue('comodato_start_date', value)
              }
              onBlur={() => formik.setFieldTouched('comodato_start_date', true)}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha final de contrato comodato"
              name="comodato_end_date"
              value={formik.values.comodato_end_date}
              error={formik.errors.comodato_end_date}
              touched={formik.touched.comodato_end_date}
              onChange={(value) =>
                formik.setFieldValue('comodato_end_date', value)
              }
              onBlur={() => formik.setFieldTouched('comodato_end_date', true)}
            />
          </Col>
        </Row>
      )}
      {/* Acuerdo interadministrativo */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.ACUERDO_INTERADMINISTRATIVO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Número de acuerdo interadministrativo"
              name="interadmin_agreement_number"
              placeholder="número Acuerdo"
              type="text"
              value={formik.values.interadmin_agreement_number}
              error={formik.errors.interadmin_agreement_number}
              touched={formik.touched.interadmin_agreement_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha inicial acuerdo interadministrativo"
              name="interadmin_start_date"
              value={formik.values.interadmin_start_date}
              error={formik.errors.interadmin_start_date}
              touched={formik.touched.interadmin_start_date}
              onChange={(value) =>
                formik.setFieldValue('interadmin_start_date', value)
              }
              onBlur={() =>
                formik.setFieldTouched('interadmin_start_date', true)
              }
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormDatePicker
              label="Fecha final acuerdo interadministrativo"
              name="interadmin_end_date"
              value={formik.values.interadmin_end_date}
              error={formik.errors.interadmin_end_date}
              touched={formik.touched.interadmin_end_date}
              onChange={(value) =>
                formik.setFieldValue('interadmin_end_date', value)
              }
              onBlur={() => formik.setFieldTouched('interadmin_end_date', true)}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
        </Row>
      )}

      {/* Decomiso */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.INCAUTADO_CON_FINES_DE_COMISO?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Fiscalía"
              name="decomiso_court_number"
              placeholder="Inserte"
              type="text"
              value={formik.values.decomiso_court_number}
              error={formik.errors.decomiso_court_number}
              touched={formik.touched.decomiso_court_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Noticia criminal"
              name="decomiso_process_number"
              placeholder="Inserte"
              type="text"
              value={formik.values.decomiso_process_number}
              error={formik.errors.decomiso_process_number}
              touched={formik.touched.decomiso_process_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Inserte"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
        </Row>
      )}

      {/* ORDEN JUDICIAL */}
      {formik.values.entry_type?.toLowerCase() ===
        ENTRY_TYPE.ORDEN_JUDICIAL?.toLowerCase() && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Valor factura/adquisición/Avalúo/Peritaje"
              name="entry_value"
              type="text"
              placeholder="Valor factura"
              value={
                formik.values.entry_value
                  ? formatNumber(formik.values.entry_value)
                  : ''
              }
              error={formik.errors.entry_value}
              touched={formik.touched.entry_value}
              onChange={(e) => handleInvoiceValueChange(e, formik)}
              onBlur={formik.handleBlur}
              prefix="$"
            />
          </Col>
        </Row>
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <CustomTextArea
            label="Observaciones"
            name="observations"
            placeholder="Observaciones"
            value={formik.values.observations}
            error={formik.errors.observations}
            touched={formik.touched.observations}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
      {/* INFORMACION DE CONTACTO */}
      {formik.values.entry_type?.toLowerCase() !==
        ENTRY_TYPE.ORDEN_COMPRA?.toLowerCase() &&
        formik.values.entry_type?.toLowerCase() !==
          ENTRY_TYPE.CONTRATO?.toLowerCase() &&
        formik.values.entry_type?.toLowerCase() !==
          ENTRY_TYPE.ORDEN_JUDICIAL?.toLowerCase() &&
        formik.values.entry_type !== '' && (
          <>
            <div className="ContactoTitleModalEntradas">
              <CustomText text="Información de contacto" />
              <Divider />
            </div>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <FormInput
                  label="NIT"
                  name="contact_nit"
                  placeholder="Ej: 123456789-2"
                  type="text" // DEBE SER "text" porque "number" no permite guiones
                  value={formik.values.contact_nit}
                  error={formik.errors.contact_nit}
                  touched={formik.touched.contact_nit}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <FormInput
                  label="Nombre"
                  name="contact_name"
                  placeholder="Nombre"
                  value={formik.values.contact_name}
                  error={formik.errors.contact_name}
                  touched={formik.touched.contact_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <FormInput
                  label="Persona de contacto"
                  name="contact_person"
                  placeholder="Persona de contacto"
                  value={formik.values.contact_person}
                  error={formik.errors.contact_person}
                  touched={formik.touched.contact_person}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <FormInput
                  label="Télefono de contacto"
                  name="contact_phone"
                  placeholder="Télefono de contacto"
                  value={formik.values.contact_phone}
                  error={formik.errors.contact_phone}
                  touched={formik.touched.contact_phone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
            </Row>
          </>
        )}
      <Divider />
      <Row align="middle" justify="center" style={{ marginBottom: '20px' }}>
        <Col flex="auto" style={{ textAlign: 'start' }}>
          <Title level={4} style={{ margin: 0 }}>
            Documentos cargados
          </Title>
        </Col>
        <Col>
          <Button
            disabled={formik.values.other_deliver === '1' ? false : true}
            type="primary"
            onClick={() => setIsOpen?.(true)}
          >
            Entrega en otras seccionales
          </Button>
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <UploadWithTable onFilesChange={onFiles} files={files} />
        </Col>
      </Row>
    </>
  );
};

export default EntryRequestCreateView;
